import debounce from "lodash/debounce";
import {
  Box,
  Button,
  Chip,
  Divider,
  FormControl,
  FormLabel,
} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {borderRadius, Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import {
  MANDATORY_QUES,
  PERCENTAGE_EXCEED_ERR,
} from "../../../constants/constants";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {GET_ADDRESS, PROPOSAL_FORM} from "../../../constants/apiConstant";
import {
  initialFormValidations,
  parseToNumber,
  removeCookies,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {useNavigate} from "react-router-dom";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import {MdOutlineDone} from "react-icons/md";
import GlobalModal from "../../global-fields/GlobalModal";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import minusIcon from "../../../assets/img/proposal-img/minus_icon.svg";
import GlobalErrorMsgBox from "../../global-fields/GlobalErrorMsgBox";
import GlobalSearchDropdown from "../../global-fields/GlobalSearchDropdown";
import {useRef} from "react";

const MinRefLimit = 1; // Minimum required trade references
const MaxRefLimit = 5; // Maximum allowed trade references

const StepTwelveForm = ({leftGridWidth}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep12Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const {submitConfirmModal} = useSelector(selectUiState);
  const [disableDraft, setDisableDraft] = useState(false);
  const [digitalSigntaureCheck, setDigitalSigntaureCheck] = useState(true);
  const [addressArr, setAddressArr] = useState([]);
  const [signingUrl, setSigningUrl] = useState(null);
  // {
  //     "url": "https://demo.docusign.net/Signing/MTRedeem/v1/54984548-xxxx-xxxx-xxxx-cd0772818bbf?slt=eyJ0eX...m87j8w"
  //   }
  // useEffect(() => {
  //     //   if (submitConfirmModal) {
  //         //setSigningUrl("https://demo.docusign.net/Signing/MTRedeem/v1/54984548-xxxx-xxxx-xxxx-cd0772818bbf?slt=eyJ0eX...m87j8w")

  //     getSigningUrl();
  //     //}
  // }, []);

  const getSigningUrl = async () => {
    try {
      const response = await fetch(
        "https://demo.docusign.net/restapi/v2.1/accounts/YOUR_ACCOUNT_ID/envelopes/YOUR_ENVELOPE_ID/views/recipient",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer YOUR_ACCESS_TOKEN`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            returnUrl: "https://your-app.com/thank-you",
            authenticationMethod: "none",
            userName: "John Doe",
            email: "recipient@example.com",
            recipientId: "1",
            clientUserId: "1234",
          }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setSigningUrl(result.url);
      } else {
        console.error("Error:", result);
      }
    } catch (error) {
      console.error("Error getting signing URL:", error);
    }
  };

  //   const getSigningUrl = async () => {
  //       try {
  //           const apiClient = new docusign.ApiClient();
  //           apiClient.setBasePath("https://demo.docusign.net/restapi");
  //           apiClient.addDefaultHeader("Authorization", "Bearer YOUR_ACCESS_TOKEN");

  //           const envelopesApi = new docusign.EnvelopesApi(apiClient);
  //           const viewRequest = {
  //               returnUrl: "https://your-app.com/thank-you",
  //               authenticationMethod: "none",
  //               userName: "John Doe",
  //               email: "recipient@example.com",
  //               recipientId: "1",
  //               clientUserId: "1234"
  //           };

  //           const envelopeId = "YOUR_ENVELOPE_ID"; // You need to generate/send this first
  //           const results = await envelopesApi.createRecipientView("YOUR_ACCOUNT_ID", envelopeId, { recipientViewRequest: viewRequest });

  //           setSigningUrl(results.url);
  //       } catch (error) {
  //           console.error("Error getting signing URL:", error);
  //       }
  //   };

  const handleStepData = (e, reviewBtn, saveBtn) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }

    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      final_submit: true,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }
    if (reviewBtn || saveBtn || e?.save_draft) {
      data = {...data, final_submit: false};
    }

    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          // GlobalNotificationPopup({ type: "error", message: res?.message });
          // removeCookies("isLogin");
          formik.resetForm();
        } else if (res.status == 1) {
          if (reviewBtn) {
            dispatch(setUiData({submitConfirmModal: false}));

            dispatch(
              setDataStore({
                proposalStep: 1,
              })
            );
            setSigningUrl(null);
            return;
          }
          if (saveBtn) {
            dispatch(setUiData({submitConfirmModal: false}));
            navigate("/dashboard");
            dispatch(
              setDataStore({
                proposalStep: 1,
                proposal_id: null,
                previous_proposal_id: null,
                editingSubmitted: false,
                clickedSteps: [],
              })
            );
            setSigningUrl(null);
            return;
          }
          if (e?.save_draft) {
            setDisableDraft(false);
            dispatch(
              setUiData({
                showLoader: false,
              })
            );
            return;
          }
          // dispatch(
          //   setAuthData({
          //     user_id: res?.user_id,
          //   })
          // );
          formik.resetForm();

          // dispatch(
          //   setUiData({
          //     showLoader: false,
          //   })
          // );
          // return;

          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          // GlobalNotificationPopup({
          //     type: "success",
          //     message: "Proposal Form Submitted Successfully.",
          // });
          GlobalNotificationPopup({type: "success", message: res?.message});
          dispatch(setUiData({submitConfirmModal: false}));

          navigate(`/dashboard`);
          dispatch(
            setDataStore({
              proposalStep: 1,
              proposal_id: null,
              previous_proposal_id: null,
              editingSubmitted: false,
              clickedSteps: [],
            })
          );
          // setCookies("isLogin", "true");
          // navigate(`/login`);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        formik.resetForm();
        navigate("/");
      });
  };

  const propStep12DataMemoize = useMemo(
    () => (propStep12Data ? propStep12Data : null),
    [propStep12Data]
  );

  const initialValues = {
    step: 12,
    trade_references: propStep12DataMemoize?.trade_references?.length
      ? propStep12DataMemoize?.trade_references?.map((ref) => ({
          company_name: ref.company_name ?? "",
          individual_name: ref.individual_name ?? "",
          street: ref.street ?? "",
          apartment: ref.apartment ?? "",
          city: ref.city ?? "",
          state: ref.state ?? "",
          zip: ref.zip ?? "",
          email: ref.email ?? "",
          phone: ref.phone ?? "",
        }))
      : [
          {
            company_name: "",
            individual_name: "",
            email: "",
            phone: "",
            street: "",
            apartment: "",
            city: "",
            state: "",
            zip: "",
          },
          // {
          //     company_name: "",
          //     individual_name: "",
          //     email: "",
          //     phone: "",
          //     street: "",
          //     apartment: "",
          //     city: "",
          //     state: "",
          //     zip: "",
          // },
        ],
  };

  // useEffect(() => {
  //   console.log("123")
  //   fetchStateCityPostal()
  //   if (propStep12DataMemoize) {

  //     formik.setValues(initialValues);
  //   }
  // }, [propStep12DataMemoize]);
  // useEffect(() => {
  //   fetchStateCityPostal();
  // }, []);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      trade_references: Yup.array().of(
        Yup.object({
          company_name: Yup.string(),
          individual_name: Yup.string(),
          street: Yup.string()
            .nullable()
            .max(100, "Street can't exceed 100 characters"),
          apartment: Yup.string()
            .nullable()
            .max(100, "Apartment can't exceed 100 characters"),

          city: Yup.string()
            .nullable()
            .matches(
              /^[A-Za-z\s]+$/,
              "Enter a valid state name (Alphabets only)."
            ),
          state: Yup.string()
            .nullable()
            .matches(
              /^[A-Za-z\s]+$/,
              "Enter a valid state name (Alphabets only)."
            ),
          zip: Yup.string()
            .nullable()
            .matches(
              /^\d{5}(-\d{4})?$/,
              "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
            ),
          email: Yup.string().email("Enter a valid email address!"),
          phone: Yup.string().matches(
            /^[0-9]{10,}$/,
            "Enter a valid mobile number with at least 10 digits."
          ),
        })
      ),
      // .min(3, "Minimum 3 Trade References are Required."),
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 12:", values);
      dispatch(setUiData({submitConfirmModal: true}));
    },
  });

  // console.log("propStep12DataMemoize", propStep12DataMemoize, initialValues)
  const handleReviewBtn = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        const key = Object.keys(item)[0];
        const value = Object.values(item)[0];

        if (key === "s12") {
          return {[key]: 2};
        }
        return {[key]: value};
      });
      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );
      handleStepData(formik.values, true, false);
    } else {
      handleStepData(formik.values, true, false);
    }
  };
  const handleSaveBtn = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        const key = Object.keys(item)[0];
        const value = Object.values(item)[0];

        if (key === "s12") {
          return {[key]: 2};
        }
        return {[key]: value};
      });
      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );
      handleStepData(formik.values, false, true);
    } else {
      handleStepData(formik.values, false, true);
    }
  };

  const handleSubmitProp = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        const key = Object.keys(item)[0];
        const value = Object.values(item)[0];

        if (key === "s12") {
          return {[key]: 2};
        }
        return {[key]: value};
      });
      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );
      handleStepData(formik.values, false, false);
    } else {
      handleStepData(formik.values, false, false);
    }
  };

  const handlePlus = () => {
    // return
    const lastIndex = formik.values.trade_references.length - 1;
    const lastEntry = formik.values.trade_references[lastIndex];
    // Check if all fields in the last entry are filled
    const isLastEntryValid = Object.values(lastEntry).every(
      (value) => value.trim() !== ""
    );

    if (!isLastEntryValid) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }
    fetchStateCityPostal("", "", formik.values.trade_references.length, "");
    formik.setFieldValue("trade_references", [
      ...formik.values.trade_references,
      {
        company_name: "",
        individual_name: "",
        street: "",
        apartment: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        phone: "",
      },
    ]);
  };

  const fetchStateCityPostal = (type, value, index = 0, currentData) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {user_id: user?.id};
    if (currentData) {
      data = {
        user_id: user?.id,
        state: currentData.state,
        city: currentData.city,
        zip: currentData.zip,
      };
    }
    if (type) {
      data = {...data, [type]: value};
    }

    const options = {
      method: GET_ADDRESS.method,
      headers: GET_ADDRESS.headers,
      body: JSON.stringify(data),
    };

    fetch(GET_ADDRESS.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          formik.resetForm();
        } else if (res.status == 1) {
          // dispatch(
          //   setDataStore({
          //     proposalStep: proposalStep + 1,
          //   })
          // );

          let responseArr = [res.data];

          setAddressArr((prev) => {
            const newAddressArr = [...prev];
            newAddressArr[index] = {
              state: responseArr?.[0]?.state || [],
              city: responseArr?.[0]?.city || [],
              zip: responseArr?.[0]?.zip || [],
            };
            return newAddressArr;
          });

          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };
  // useEffect(() => {
  //   fetchStateCityPostal();
  // }, []);

  // console.log("formik", formik.values, addressArr);

  const handleAdressDataOLD = (type = "state", field, value, index) => {
    // Call API to fetch state/city/zip list based on current input

    // Clone current trade references
    const currentTradeRefs = [...formik.values.trade_references];

    // console.log("currentTradeRefs", index, currentTradeRefs[index]);

    if (type === "state" && value === "") {
      // Clear state, city, and zip at the given index
      currentTradeRefs[index] = {
        ...currentTradeRefs[index],
        state: "",
        city: "",
        zip: "",
      };
      // console.log("currentTradeRefs 2222", currentTradeRefs);
      fetchStateCityPostal(type, value, index, currentTradeRefs[index]);

      formik.setFieldValue("trade_references", currentTradeRefs);
      return;
    }

    if (type === "city" && value === "") {
      // Clear city and zip at the given index
      currentTradeRefs[index] = {
        ...currentTradeRefs[index],
        city: "",
        zip: "",
      };

      // console.log("currentTradeRefs 33333333", currentTradeRefs);
      fetchStateCityPostal(type, value, index, currentTradeRefs[index]);

      formik.setFieldValue("trade_references", currentTradeRefs);
      return;
    }
    fetchStateCityPostal(type, value, index, currentTradeRefs[index]);

    // Otherwise, just update the current field
    formik.setFieldValue(field, value);
  };
  const debouncedFetch = useRef(
    debounce((type, value, index, currentData) => {
      fetchStateCityPostal(type, value, index, currentData);
    }, 750)
  ).current;

  const handleAdressData = (type = "state", field, value, index) => {
    const currentTradeRefs = [...formik.values.trade_references];

    if (type === "state" && value === "") {
      currentTradeRefs[index] = {
        ...currentTradeRefs[index],
        state: "",
        city: "",
        zip: "",
      };
      debouncedFetch(type, value, index, currentTradeRefs[index]);
      formik.setFieldValue("trade_references", currentTradeRefs);
      return;
    }

    if (type === "city" && value === "") {
      currentTradeRefs[index] = {
        ...currentTradeRefs[index],
        city: "",
        zip: "",
      };
      debouncedFetch(type, value, index, currentTradeRefs[index]);
      formik.setFieldValue("trade_references", currentTradeRefs);
      return;
    }

    // Debounced call
    debouncedFetch(type, value, index, currentTradeRefs[index]);

    // Update field value
    formik.setFieldValue(field, value);
  };

  // console.log("formik", formik.errors);
  //console.log("formik", formik.dirty, formik.values, formik.errors);

  const handleMinus = (index) => {
    if (formik.values.trade_references.length > MinRefLimit) {
      const updatedReferences = [...formik.values.trade_references];
      updatedReferences.splice(index, 1);
      // formik.setFieldValue("trade_references", updatedReferences);

      formik.setValues({
        ...formik.values,
        trade_references: updatedReferences,
      });
      formik.setTouched({});
      formik.setErrors({});
    }
  };

  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 12) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals, false, false);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}{" "}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Trade References</h2>
            {/* <h2 className={style.formTitleh2}>
              24) Please share minimum 3 Trade References
            </h2> */}

            <h2 className={style.formTitleh2}>
              22) Please share Trade References
            </h2>

            <form
              onSubmit={handleCustomSubmit}
              autoComplete="false"
              autoSave="false"
            >
              {formik.values.trade_references.map((trade, refIndex) => (
                <Grid
                  container
                  key={`trade-ref-${refIndex}-`}
                  spacing={2}
                  sx={{mt: 1}}
                >
                  <Grid size={{xs: 12, md: 8, lg: 10, xl: 8}}>
                    <div
                      className={
                        style.plusIconMain + " " + style.TwelveFormAddMore
                      }
                    >
                      <div className={style.plusImgMain}>
                        {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                        {formik.values.trade_references.length <
                          MaxRefLimit && (
                          <p
                            style={{
                              position: "inherit",
                              display: "flex",
                            }}
                            onClick={() => handlePlus()}
                          >
                            <img
                              src={plusIcon}
                              alt="Add"
                              style={{marginRight: "5px"}}
                            />
                            Add
                          </p>
                        )}
                      </div>
                    </div>

                    <Grid container spacing={2}>
                      <Grid size={{xs: 12}}>
                        {refIndex !== 0 && (
                          <Box sx={{width: "100%", mt: 1, mb: 1}}>
                            <Divider>
                              <Chip
                                label={`${refIndex + 1}`}
                                size="medium"
                                onDelete={() => handleMinus(refIndex)}
                              />
                            </Divider>
                          </Box>
                        )}
                      </Grid>
                      <Grid size={{xs: 12, sm: 6, lg: 6, xl: 6}}>
                        <FormControl fullWidth sx={{mt: 0}}>
                          <FormLabel className={style.labelText} sx={{mb: 1}}>
                            Company Name
                          </FormLabel>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].company_name`}
                            id={`trade_references_${refIndex}_company_name`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]
                                ?.company_name
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.company_name &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.company_name
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.company_name &&
                              formik.errors?.trade_references?.[refIndex]
                                ?.company_name
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid size={{xs: 12, sm: 6, lg: 6, xl: 6}}>
                        <FormControl fullWidth sx={{mt: 0}}>
                          <FormLabel className={style.labelText} sx={{mb: 1}}>
                            Individual Name
                          </FormLabel>

                          <GlobalTextField
                            name={`trade_references[${refIndex}].individual_name`}
                            id={`trade_references_${refIndex}_individual_name`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]
                                ?.individual_name
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.individual_name &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.individual_name
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.individual_name &&
                              formik.errors?.trade_references?.[refIndex]
                                ?.individual_name
                            }
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid size={{xs: 12, md: 8, lg: 10, xl: 8}}>
                    <Grid container spacing={2}>
                      <Grid size={{xs: 12, sm: 6, lg: 6, xl: 6}}>
                        <FormControl fullWidth sx={{mt: 1}}>
                          <FormLabel sx={{mb: 1}}>Email</FormLabel>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].email`}
                            id={`trade_references_${refIndex}_email`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]?.email
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.email &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.email
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.email &&
                              formik.errors?.trade_references?.[refIndex]?.email
                            }
                          />
                        </FormControl>
                      </Grid>

                      <Grid size={{xs: 12, sm: 6, lg: 6, xl: 6}}>
                        <FormControl fullWidth sx={{mt: 1}}>
                          <FormLabel sx={{mb: 1}}>Phone</FormLabel>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].phone`}
                            id={`trade_references_${refIndex}_phone`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]?.phone
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.phone &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.phone
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.phone &&
                              formik.errors?.trade_references?.[refIndex]?.phone
                            }
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid size={{xs: 12, lg: 10, xl: 8}}>
                    <Grid container spacing={2} sx={{mt: 1}}>
                      <Grid size={{xs: 12, md: 6}}>
                        <div style={{width: "100%"}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{mb: 1}}>Street Name</FormLabel>
                          </FormControl>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].street`}
                            id={`trade_references_${refIndex}_street`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]
                                ?.street
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.street &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.street
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.street &&
                              formik.errors?.trade_references?.[refIndex]
                                ?.street
                            }
                          />
                        </div>
                      </Grid>
                      <Grid size={{xs: 12, md: 6, sm: 6}}>
                        <div style={{width: "100%"}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{mb: 1}}>
                              Apartment/Suite/Floor
                            </FormLabel>
                          </FormControl>

                          <GlobalTextField
                            name={`trade_references[${refIndex}].apartment`}
                            id={`trade_references_${refIndex}_apartment`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]
                                ?.apartment
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.apartment &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.apartment
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.apartment &&
                              formik.errors?.trade_references?.[refIndex]
                                ?.apartment
                            }
                          />
                        </div>
                      </Grid>

                      <Grid size={{xs: 12, md: 4, sm: 6}}>
                        <div style={{width: "100%"}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{mb: 1}}> State </FormLabel>
                          </FormControl>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].state`}
                            id={`trade_references_${refIndex}_state`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]?.state
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.state &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.state
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.state &&
                              formik.errors?.trade_references?.[refIndex]?.state
                            }
                          />
                          {/* <GlobalSearchDropdown
                            name={`trade_references[${refIndex}].state`}
                            id={`trade_references_${refIndex}_state`}
                            value={
                              formik.values?.trade_references?.[refIndex]?.state
                            }
                            options={addressArr?.[refIndex]?.state || []}
                            onChange={(e) =>
                              handleAdressData(
                                "state",
                                `trade_references[${refIndex}].state`,
                                e.target.value,
                                refIndex
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.state &&
                              formik.errors?.trade_references?.[refIndex]
                                ?.state
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.state &&
                              formik.errors?.trade_references?.[refIndex]?.state
                            }
                            stateField={true}
                            fetchStates={() => fetchStateCityPostal("state")}
                          /> */}
                        </div>
                      </Grid>
                      <Grid size={{xs: 12, md: 4, sm: 6}}>
                        <div style={{width: "100%"}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{mb: 1}}> City </FormLabel>
                          </FormControl>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].city`}
                            id={`trade_references_${refIndex}_city`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]?.city
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.city &&
                                formik.errors?.trade_references?.[refIndex]
                                  ?.city
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.city &&
                              formik.errors?.trade_references?.[refIndex]?.city
                            }
                          />
                          {/* <GlobalSearchDropdown
                            name={`trade_references[${refIndex}].city`}
                            id={`trade_references_${refIndex}_city`}
                            value={
                              formik.values?.trade_references?.[refIndex]?.city
                            }
                            options={addressArr?.[refIndex]?.city || []}
                            onChange={(e) =>
                              handleAdressData(
                                "city",
                                `trade_references[${refIndex}].city`,
                                e.target.value,
                                refIndex
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.city &&
                              formik.errors?.trade_references?.[refIndex]
                                ?.city
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.city &&
                              formik.errors?.trade_references?.[refIndex]?.city
                            }
                            disabled={
                              formik.values?.trade_references?.[refIndex]
                                ?.state === ""
                            }
                          /> */}
                        </div>
                      </Grid>
                      <Grid size={{xs: 12, md: 4, sm: 6}}>
                        <div style={{width: "100%"}}>
                          <FormControl fullWidth>
                            <FormLabel sx={{mb: 1}}> Zip Code</FormLabel>
                          </FormControl>
                          <GlobalTextField
                            name={`trade_references[${refIndex}].zip`}
                            id={`trade_references_${refIndex}_zip`}
                            type="text"
                            value={
                              formik.values?.trade_references?.[refIndex]?.zip
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.zip &&
                                formik.errors?.trade_references?.[refIndex]?.zip
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.zip &&
                              formik.errors?.trade_references?.[refIndex]?.zip
                            }
                          />
                          {/* <GlobalSearchDropdown
                            name={`trade_references[${refIndex}].zip`}
                            id={`trade_references_${refIndex}_zip`}
                            value={
                              formik.values?.trade_references?.[refIndex]?.zip
                            }
                            options={addressArr?.[refIndex]?.zip || []}
                            onChange={(e) =>
                              handleAdressData(
                                "zip",
                                `trade_references[${refIndex}].zip`,
                                e.target.value,
                                refIndex
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={Boolean(
                              formik.touched?.trade_references?.[refIndex]
                                ?.zip &&
                              formik.errors?.trade_references?.[refIndex]?.zip
                            )}
                            helperText={
                              formik.touched?.trade_references?.[refIndex]
                                ?.zip &&
                              formik.errors?.trade_references?.[refIndex]?.zip
                            }
                            disabled={
                              formik.values?.trade_references?.[refIndex]
                                ?.state === "" ||
                              formik.values?.trade_references?.[refIndex]
                                ?.city === ""
                            }
                          /> */}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
              {/* <Grid container spacing={2}>
                                <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
                                    <h3 className={style.htitleText}>Digital Signature*</h3>
                                </Grid>
                                <Grid size={{ xs: 12, md: 8, xl: 8 }}>

                                    <Box
                                        sx={{ mb: 1, p: 0 }} className={style.consentContent}>
                                        {signingUrl ? (
                                            <iframe
                                                src={signingUrl}
                                                title="DocuSign Signature"
                                                width="100%"
                                                height="250px"
                                                style={{ border: "none", borderRadius: '10px' }}
                                            ></iframe>
                                        ) : (
                                            <Box
                                                style={{
                                                    height: 250,
                                                    width: "100%",
                                                    backgroundColor: "#f2f2f2",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "10px"

                                                }}
                                            >
                                                <h4>LOADING...</h4>
                                            </Box>
                                        )}

                                        <ul className={style.digitalSignDone}>
                                            <li>
                                                <div>
                                                    {!digitalSigntaureCheck ? (
                                                        <MdOutlineDone />
                                                    ) : (
                                                        <MdOutlineDone className={style.active} />
                                                    )}
                                                </div>{" "}
                                                <p> Digitally Signatured </p>
                                            </li>
                                        </ul>
                                        <p>
                                            <strong>
                                                <u>NOTE :</u>
                                            </strong>{" "}
                                            This proposal & declaration must signed digitally.
                                        </p>
                                    </Box>

                                </Grid>
                            </Grid> */}
            </form>
            {typeof formik.errors?.trade_references == "string" ? (
              <GlobalErrorMsgBox
                errMessage={formik.errors?.trade_references}
                margin={false}
              />
            ) : null}
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={false}
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
      <GlobalModal
        open={submitConfirmModal}
        //open={true}
        maxWidth="xs"
        handleClose={() => dispatch(setUiData({submitConfirmModal: false}))}
        // handleClose={handleClose}
        aria-labelledby="claim-history"
        closeIcon={true}
        title={"Are you Sure?"}
        // subtitle={"You Want To Submit The Proposal Form."}
        dialogTitleClass={style.claimPopTitle}
        //disableBackdropClick={true}
        dialogContent={
          <Grid container spacing={0}>
            <Box sx={{mb: 3, mt: 0, textAlign: "center", width: "100%"}}>
              <p> Choose an action for the proposal form below :</p>

              {/* <Box
                style={{
                  height: 350,
                  width: "100%",
                  backgroundColor: "#eee",
                }}
              >
                {signingUrl ? (
                  <iframe
                    src={signingUrl}
                    title="DocuSign Signature"
                    width="100%"
                    height="350px"
                    style={{ border: "none" }}
                  ></iframe>
                ) : (
                  <Box
                    style={{
                      height: 350,
                      width: "100%",
                      backgroundColor: "#eee",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <h3>LOADING...</h3>
                  </Box>
                )}
              </Box> */}
            </Box>

            <Grid
              size={{xs: 12, md: 12}}
              sx={{textAlign: "center"}}
              className={style.consentContentBtn}
            >
              <Button
                variant="contained"
                sx={{mr: 1}}
                onClick={handleReviewBtn}
              >
                Review
              </Button>
              <Button
                sx={{mr: 1}}
                variant="contained"
                onClick={handleSubmitProp}
                //disabled={!signingUrl}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                // sx={{mr: 1}}
                onClick={handleSaveBtn}
              >
                Save & Exit
              </Button>
            </Grid>
          </Grid>
        }
      ></GlobalModal>
    </>
  );
};

export default StepTwelveForm;
